import { render, staticRenderFns } from "./edit_v1.vue?vue&type=template&id=3286de7b&scoped=true&"
import script from "./edit_v1.vue?vue&type=script&lang=js&"
export * from "./edit_v1.vue?vue&type=script&lang=js&"
import style0 from "./edit_v1.vue?vue&type=style&index=0&id=3286de7b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286de7b",
  null
  
)

export default component.exports